<template>
    <div class="header-landing-page-button-container">
        <header class="header-landing-page-button">
            <div class="header-landing-page-button__inner">
                <div class="header-landing-page-button__top">
                    <component
                        :is="visualHeadings ? 'span' : 'h1'"
                        v-if="title"
                        class="header-landing-page-button__heading u-heading-1"
                    >
                        {{ decodeHtmlEntities(title) }}
                    </component>
                </div>
                <div
                    v-if="ctaBlock"
                    class="header-landing-page-button__content"
                >
                    <div class="header-landing-page-button__left">
                        <slot name="visual"></slot>

                        <div
                            v-if="ctaBlock"
                            class="header-landing-page-button__form"
                        >
                            <div
                                v-if="ctaBlockOverwrite.heading || ctaBlock.heading"
                                class="header-landing-page-button__cta-title u-heading-5"
                            >
                                {{ ctaBlockOverwrite.heading || ctaBlock.heading }}
                            </div>

                            <div class="header-landing-page-button__cta-questions">
                                <div
                                    v-if="ctaBlock.question"
                                    class="header-landing-page-button__question u-heading-3 u-bold"
                                >
                                    {{ ctaBlock.question }}
                                </div>

                                <div
                                    :class="[
                                        'header-landing-page-button__button-container',
                                        {
                                            'header-landing-page-button__button-container--always-double': ctaBlock.questionButtonLayout,
                                        }
                                    ]"
                                >
                                    <DsAtomButton
                                        v-for="button in ctaBlock.buttons"
                                        size="medium"
                                        class="header-landing-page-button__button"
                                        :text="button.text"
                                        :icon-right="button.icon"
                                        :full-width="true"
                                        @click="submitForm(button)"
                                    />
                                </div>

                                <div
                                    v-if="ctaBlock.questionInformation"
                                    class="header-landing-page-button__question-information u-tiny-text"
                                >
                                    {{ ctaBlock.questionInformation }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="ctaBlock && ctaBlock.usps"
                        class="header-landing-page-button__usps"
                    >
                        <WatsonOrganismContentColumnCheckmarks
                            :content="{}"
                            :items="ctaBlock.usps.items"
                            column-count="1"
                            :turn-on-background="false"
                            :background="null"
                            :icon-color="ctaBlock.usps.iconColor"
                            :text-color="ctaBlock.usps.textColor"
                            :typography="ctaBlock.usps.typography"
                            media-position="next-to-text"
                        />
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script setup>
import { DsAtomButton } from 'design-system-component-library/marketplaces';

import WatsonOrganismContentColumnCheckmarks from '@organisms/content-column-checkmarks/watson-organism-content-column-checkmarks.vue';
import { handleClickAction } from '@utils/click-action';
import decodeHtmlEntities from '../../../js/utils/decode-html-entities';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: null,
    },
    subtitle: {
        type: String,
        required: false,
        default: '',
    },
    visualHeadings: {
        type: Boolean,
        required: false,
        default: false,
    },
    ctaBlock: {
        type: Object,
        required: false,
        default: null,
    },
    ctaBlockOverwrite: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    background: {
        type: String,
        required: false,
        default: null,
    },
    backgroundForm: {
        type: String,
        required: false,
        default: null,
    },
    textColor: {
        type: String,
        required: false,
        default: null,
    },
});

const submitForm = button => {
    handleClickAction(props.ctaBlock.clickAction, button.value);
};

const colors = computed(() => {
    if (props.ctaBlock !== null) {
        return {
            questionColor: props.ctaBlock.style.questionColor || null,
            questionInformationColor: props.ctaBlock.style.questionInformationColor || null,
            backgroundForm: props.ctaBlock.style.backgroundForm || null,
        };
    }

    return {
        questionColor: null,
        questionInformationColor: null,
        backgroundForm: null,
    };
});
</script>

<style lang="scss">
@use 'watson-organism-header-landing-page-button';
</style>

<style lang="scss" scoped>
@layer organism {
    .header-landing-page-button {
        --question-color: v-bind('colors.questionColor');
        --question-information-color: v-bind('colors.questionInformationColor');
        --background-form: v-bind('colors.backgroundForm');
        --background: v-bind('props.background || null');
        --text-color: v-bind('props.textColor || null');
    }
}
</style>
